import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiCreateIapPollRequestBody,
  IApiCreateIapPollResponseBody,
  IApiDeleteIapPollResponseBody,
  IApiGetIapPollResponseBody,
  IApiGetIapPollResultsQueryBody,
  IApiGetIapPollResultsResponseBody,
  IApiGetIapPollsRequestBody,
  IApiGetIapPollsResponseBody,
  IApiUpdateIapPollRequestBody,
  IApiUpdateIapPollResponseBody,
} from './IapPollsApi.types';

export class IapPollsApi {
  public constructor(private client: ApiClient) {}

  public async getAll(
    appId: string,
    params?: IApiGetIapPollsRequestBody,
  ): Promise<IApiGetIapPollsResponseBody> {
    const request: IApiJsonRequest = {
      path: '/admin/press/iapPolls',
      method: 'get',
      params,
    };

    const response =
      await this.client.fetchJsonStandardized<IApiGetIapPollsResponseBody>(
        request,
        { appId },
      );

    return response;
  }

  public async get(
    appId: string,
    iapPollId: string,
  ): Promise<IApiGetIapPollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/iapPolls/${iapPollId}`,
      method: 'get',
    };

    const response =
      await this.client.fetchJsonStandardized<IApiGetIapPollResponseBody>(
        request,
        { appId },
      );

    return response;
  }

  public async getResults(
    appId: string,
    iapPollId: string,
    body?: IApiGetIapPollResultsQueryBody,
  ): Promise<IApiGetIapPollResultsResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/iapPolls/${iapPollId}/results`,
      method: 'get',
      params: body,
    };

    const response =
      await this.client.fetchJsonStandardized<IApiGetIapPollResultsResponseBody>(
        request,
        {
          appId,
        },
      );

    return response;
  }

  public async create(
    appId: string,
    body: IApiCreateIapPollRequestBody,
  ): Promise<IApiCreateIapPollResponseBody> {
    const request: IApiJsonRequest = {
      path: '/admin/press/iapPolls',
      method: 'post',
      body,
    };

    const response =
      await this.client.fetchJsonStandardized<IApiCreateIapPollResponseBody>(
        request,
        { appId },
      );

    return response;
  }

  public async update(
    appId: string,
    iapPollId: string,
    body: IApiUpdateIapPollRequestBody,
  ): Promise<IApiUpdateIapPollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/iapPolls/${iapPollId}`,
      method: 'patch',
      body,
    };

    const response =
      await this.client.fetchJsonStandardized<IApiUpdateIapPollResponseBody>(
        request,
        { appId },
      );

    return response;
  }

  public async delete(
    appId: string,
    iapPollId: string,
  ): Promise<IApiDeleteIapPollResponseBody> {
    const request: IApiJsonRequest = {
      path: `/admin/press/iapPolls/${iapPollId}`,
      method: 'delete',
    };

    const response =
      await this.client.fetchJsonStandardized<IApiDeleteIapPollResponseBody>(
        request,
        {
          appId,
        },
      );

    return response;
  }
}
